import { h, render, Component, createRef } from 'preact';
import { classNames } from '../utils/utils';

class TxrScrollHelper extends Component {
    state = {
        isScrolled: false,
        elements: undefined
    }
    ref = createRef();
    refContent = createRef();

    onscroll = () => {

        const offsetY=parseInt(this.props.offsetY);
        const offsetYmax=!!this.props.offsetYmax ? parseInt(this.props.offsetYmax) : undefined;
        if (window.pageYOffset >= offsetY && (!offsetYmax || window.pageYOffset < offsetYmax)) {
            if (!this.state.isScrolled) {
                this.setState({ isScrolled: true });
                Array.from(this.state.elements).forEach((element) => {
                    element.classList.add(this.props.scrollClass);
                });
            }
        }
        if (!!offsetYmax  && (window.pageYOffset >= offsetYmax)) {
            if (this.state.isScrolled) {
                this.setState({ isScrolled: false });
                Array.from(this.state.elements).forEach((element) => {
                    element.classList.remove(this.props.scrollClass);
                });
            }
        }
        if (window.pageYOffset < offsetY) {
            if (this.state.isScrolled) {
                this.setState({ isScrolled: false });
                Array.from(this.state.elements).forEach((element) => {
                    element.classList.remove(this.props.scrollClass);
                });
            }
        }
    }
    componentDidMount() {
        setTimeout(() => {
            if(this.props.elementIds) {
                window.addEventListener('scroll', this.onscroll);
                const elementIds = this.props.elementIds.split(',');
                this.state.elements = [];
                Array.from(elementIds).forEach((elementId) => {
                    const el = document.getElementById(elementId);
                    this.state.elements.push(el)
                });
            }
        }, 1000);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onscroll);
    }


    render() {
        return ('')
    }
}

export default TxrScrollHelper;